import { useMemo } from 'react'
import { useGetAdvancedSourcesQuery } from '../../advancedParticipant.generated'

export const useSources = (): string[] => {
  const { data, loading } = useGetAdvancedSourcesQuery()
  return useMemo(() => (loading || !data ? [] : data.sources.map(({ name }) => name)), [loading, data])
}
